import imomoMeteostationCreatorModule from './creator/creator.module';
import managerComponent from './manager.component';
import stationComponent from './meteostation.component';
import selectorComponent from './selector/selector.component';
import historicNormComponent from './historic-norm/historic-norm.component';
import meteoDataTableComponent from './historic-norm/meteoDataTable/meteo-data-table.component';

import detailsComponent from './details/details.component';
import detailsEditComponent from './details/edit.component';
import stationFormatterFactory from './meteostation.formatter';

import {uniqueStationCodeFactory} from './unique-station-code.directive';
import {configStates} from './meteostation.component';
import StationSelectorService from './selector/selector.service';
import timeseriesComponent from './timeseries/timeseries.component';
import timeseriesGraphComponent from './timeseries/timeseries-graph/timeseries-graph.component';

export default angular.module('imomo.meteostation', [imomoMeteostationCreatorModule.name])
    .component('imomoMeteostation', stationComponent)
    .component('imomoMeteostationManager', managerComponent)
    .component('imomoMeteostationSelector', selectorComponent)
    .component('imomoMeteostationHistoricNorm', historicNormComponent)
    .component('imomoMeteostationDataTable', meteoDataTableComponent)
    .component('imomoMeteostationDetails', detailsComponent)
    .component('imomoMeteostationDetailsEdit', detailsEditComponent)
    .component('imomoMeteostationTimeseries', timeseriesComponent)
    .component('imomoMeteostationTimeseriesGraph', timeseriesGraphComponent)
    .config(configStates)
    .filter('stationFormatter', stationFormatterFactory)
    .directive('uniqueMeteoStationCode', uniqueStationCodeFactory)
    .service('stationSelectorService', StationSelectorService)
    .name;




/** WEBPACK FOOTER **
 ** ./app/meteostation/meteostation.module.ts
 **/